import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { FuseSidebarService } from '@barebone-fuse/@fuse/components/sidebar/sidebar.service';
import { DialogService } from '@shared/services/dialog-service';
import { CommandService } from '@core/services/command.service';
import { ParticleCacheService } from '@core/services/particle-cache.service';
import { select, Store } from '@ngrx/store';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { CollaborationState } from '../../../../task-manager/collaboration/store/collaboration.reducer';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { DetailsInstructionService, InstructionDetailsSourceViewType } from '@shared/services/details-instruction-service';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { FlowChartNode, FlowChartUiFlatNode } from '../../../models/data-survey.models';
import { skip, take, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, of as observableOf, Subject } from 'rxjs';
import { CreateChatConversationCommand } from '../../../../task-manager/collaboration/store/collaboration.command';
import { ContentScope, PlatformCommand, PlatformCommandResponse } from '@shared/commands/command-base';
import { CreateChatConversationAction } from '../../../../task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '../../../../task-manager/collaboration/store/collaboration.constants';
import { DialogModel } from '@shared/models/dialog.model';
import { SetCurrentRightSideBarFoldOrNotAction, SetCurrentRightSideComponentAction, SetCurrentViewDetailAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '@shared/models/configuration';
import { QnrPermissions } from '@features/data-survey/components/flow-chart/models/qnr.models';
import { QnrFieldValidationMessage } from "@shared/constants/questionnaire.constants";
import { FieldDefinition } from "@shared/models/field-definition";
import { Api, DataTypes } from "@shared/constants/common-field.constants";
import { QnrCommandFactory } from "@features/file-manager/commands/questionnaire.commands";
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { Guid } from 'guid-typescript';
import { PlatformToolFileStoreHandler } from '@features/file-manager/services/platform-tool-file-store-handler';
import { OptionItem } from '@shared/models/option-item';
import { XatBotThreadService } from '@features/xatbot/services/xat-bot-thread.service'
import {FlowChartDataService} from "@features/data-survey/services/flow-chart-data.service";

@Component({
    standalone: false,
    selector: 'particle-platform-tool-questionnaire-response',
  templateUrl: './platform-tool-questionnaire-response.component.html',
  styleUrls: ['./platform-tool-questionnaire-response.component.scss']
})
export class PlatformToolQuestionnaireResponseComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(private snackBarService: SnackBarService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private dialogService: DialogService,
    private commandService: CommandService,
    private particleCacheService: ParticleCacheService,
    private eRef: ElementRef,
    public queryState: Store<IQueryState>,
    private collaborationStore: Store<CollaborationState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private sidebarService: FuseSidebarService,
    protected detailsInstructionService: DetailsInstructionService,
    private router: Router,
    private httpClient: HttpClient,
    private xatBotThreadService: XatBotThreadService
  ) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel,
      this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<FlowChartUiFlatNode>(this._getLevel, this._isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataChange.pipe(takeUntil(this.unsubscribe$)).subscribe(data => this.rebuildTreeForData(data));
  }

  get data(): FlowChartNode[] {
    return this.dataChange.value;
  }
  treeControl: FlatTreeControl<FlowChartUiFlatNode>;
  treeFlattener: MatTreeFlattener<FlowChartNode, FlowChartUiFlatNode>;
  dataSource: MatTreeFlatDataSource<FlowChartNode, FlowChartUiFlatNode>;
  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;

  selectedNodeId: string = '';
  @Input() section: any;
  sourceType: string;
  @Input() rowItem: any;
  @Input() fieldDefinitions: any;
  @Input() fieldVisibilities: any = {};
  @Input() magicLinkModel;
  @Input() selectedTab;
  @Output() rowItemEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() flowchart: any;
  @Input() invalidateSubject: InvalidateSubject;
  @Input() flowChartDataService: FlowChartDataService
  hasTagsMapping: any = {};
  unsubscribe$ = new Subject<void>();
  /** SHAON */
  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<FlowChartUiFlatNode, FlowChartNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<FlowChartNode, FlowChartUiFlatNode>();
  /** SHAON */

  ////////////////////////////////////// TreeBuild//////////////////////////
  dataChange = new BehaviorSubject<FlowChartNode[]>([]);
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();


  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  /** SHAON */

  transformer = (node: FlowChartNode, level: number) => {
    // return new FileFlatNode(!!node.children, node.filename, level, node.type, node.id);

    /** SHAON */
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = new FlowChartUiFlatNode(!!node.children, level, node.id, node);
    flatNode.level = level;
    flatNode.expandable = !!node.children;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
    /** SHAON */
  }
  private _getLevel = (node: FlowChartUiFlatNode) => node.level;
  private _isExpandable = (node: FlowChartUiFlatNode) => node.expandable;
  private _getChildren = (node: FlowChartNode): Observable<FlowChartNode[]> => observableOf(node.children);
  hasChild = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.children.length > 0;


  /**
   * This constructs an array of nodes that matches the DOM,
   * and calls rememberExpandedTreeNodes to persist expand state
   */
  visibleNodes(): FlowChartNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FlowChartNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id)) {
        node.children.map(child => addExpandedChildren(child, expanded));
      }
    }

    this.dataSource.data.forEach(node => {
      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }

  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */

  rebuildTreeForData(data: any) {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    this.dataSource.data = data;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(this.treeControl.dataNodes, Array.from(this.expandedNodeSet));
    this.expandAllNodes();
  }

  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id);
        }
      });
    }
  }

  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FlowChartUiFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.id === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FlowChartUiFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) {
      return;
    }
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id)) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }

  private expandAllNodes() {
    this.treeControl.dataNodes.forEach((node) => {
      this.treeControl.expand(node);
      let parent = this.getParentNode(node);
      while (parent) {
        this.treeControl.expand(parent);
        parent = this.getParentNode(parent);
      }
    });
  }

  private getParentNode(node: FlowChartUiFlatNode): FlowChartUiFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  ngOnInit(): void {
    this.sourceType = this.selectedTab.tabData['SourceType'];
    this.initialize();
  }

  /** SHAON */
  hasNoContent = (_: number, _nodeData: FlowChartUiFlatNode) => _nodeData.item.title === '';

  onSelectedNode(node: any) {
    this.selectedNodeId = node.item.id;
    //this.openDetailsAndInstructions(node); // requirement comes form masud vai confirmed by rick PO
  }


  initialize() {
    // Parse the string to json object.
    // Parse the string to json object.
    this.init();
    // if (this.flowChartDataService.isSurveyInitialized()) {
    //   this.init();
    //   return
    // }
    // this.flowChartDataService.getQualifyingSurveyFields().pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
    //   this.init();
    // }, err => {
    //   this.init();
    // })
  }

  private init() {
    const dataObject = this.section.questions
      .filter(q => !this.fieldVisibilities || this.fieldVisibilities[q.fieldKey])
      .filter(q => q.visibilityLogicGate.visibilityType !== "AlwaysHidden");


    // const dataObject = this.section.questions.filter(q => !this.fieldVisibilities || this.fieldVisibilities[q.fieldKey]); // JSON.parse(this.TREE);
    // Build the tree nodes from Json object. The result is a list of `Node` with nested
    //     file node as children.
    const data = this.buildTree(dataObject, 0);
    // Notify the change.
    this.dataChange.next(data);
  }

  /**
   * Build the file structure tree. The `value` is the Json object, or a sub-tree of a Json object.
   * The return value is the list of `Node`.
   */
  /** SHAON */
  buildTree(tree: FlowChartNode[], level: number, parentId: string = '0'): FlowChartNode[] {
    return tree.reduce<FlowChartNode[]>((accumulator, obj, idx) => {
      const node = { ...obj } as FlowChartNode;

      /**
       * Make sure your node has an id so we can properly rearrange the tree during drag'n'drop.
       * By passing parentId to buildFileTree, it constructs a path of indexes which make
       * it possible find the exact sub-array that the node was grabbed from when dropped.
       */
      node.copyId = node.id;
      node.sourceSectionId = this.section.id;
      node.hasFormulaExpression = this.hasFormulaExpression(node.dataType, node.fieldValues);
      node.useFormula = this.isUseFormula(node);
      node.hasQualifyingSurvey = this.hasQualifyingSurvey(node.title);
      // has formula expression?
      // if formula expression then decide input type
      // node.id = `${parseInt(parentId)+1}:${idx+1}`;


      if (obj != null) {
        if (typeof obj === 'object') {
          const children = obj.children.filter((q: any) => !this.fieldVisibilities || this.fieldVisibilities[q.fieldKey]);
          node.children = this.buildTree(children, level + 1, node.id);
        } else {
          console.log('not a object in tree node');
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  /** SHAON */

  ////////////////// all api call///////////

  onEdit(node: any) {
    if (node.item.metaData && node.item.metaData.SnippetId) {
      return;
    }
    if (node.item.useFormula) {
      this.snackBarService.showInformation('This field use formula expression to populate value. You can change preference from action menu.');
      return;
    }
    if (node.item.dataType === DataTypes.Questionnaire) {
      const command = QnrCommandFactory.childQnrNavigationCommand(this.rowItem.id, node.item, this.flowchart.id);
      this.executeCommandToApi(command);
      return;
    }
    console.log('node selected: ', node, this.rowItem);
    if (node.item?.formulaField && node.item.formulaField == 'yes') {
      this.showFormulaFieldValidationSnackBarMessage();
      return;
    }
    if (!node.item.isHidden && this.fieldDefinitions[node.item.fieldKey] && this.fieldDefinitions[node.item.fieldKey].isReadOnly === true && this.fieldDefinitions[node.item.fieldKey].dataType !== 'Attachment') {
      return;
    }

    if (this.flowchart?.permissions?.length > 0 && !this.flowchart?.permissions?.includes(QnrPermissions.UpdateResponse)) {
      this.snackBarService.showWarning(`You don't have permission to do this operation.`);
      return;
    }


    const minWidth = '600px';
    const maxWidth = '700px';
    const otherButtonCaption = 'Clear';

    const currentFieldDefinition = this.fieldDefinitions[node.item.fieldKey];
    currentFieldDefinition.fieldValues['ParentFieldKey'] = this.getParentNode(node)?.item?.fieldKey;

    //const backUpRowItem = JSON.parse(JSON.stringify(this.rowItem)); // keeping backup of rowItem
    this.dialogService.showCellEditorDialog(this.rowItem, currentFieldDefinition, minWidth, maxWidth, this.sourceType,
      undefined, {
      disableFieldSettings: this.selectedTab.tabData['IsFillablePdf'] ?? this.selectedTab.tabData['IsFlowExecution'],
      flowChartSectionId: this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['SurveyFlowchartSectionId'],
      flowChartId: this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex].tabData['FlowChartId'], type: 'Questionnaire'
    }, otherButtonCaption).pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      console.log('After Edit', state);

      if (state?.action === 'OK') {
        console.log('After Edit', state);
        this.fuseSplashScreenService.show();
        const command = this.magicLinkModel.additionalCommands['UpdateFlowchartItemCommand'];
        command.fieldValues['ItemId'] = this.rowItem.id;
        command.fieldValues['FieldKey'] = node.item.fieldKey;
        command.projectId = '[PROJECT_ID]'; // For Notebook Custom Rates, Project Id needed.
        command.fieldValues['FlowchartSectionId'] = this.section.id; // we set section id. discussed with Shaon vai and further review
        // todo: change flowchart section id
        if (this.rowItem.cells[node.item.fieldKey]) {
          command.fieldValues[node.item.fieldKey] = this.rowItem.cells[node.item.fieldKey].value;
        }
        this.executeCommandToApi(command, (data: PlatformCommandResponse) => {
          console.log('after response:', data);
          if (data && data.fieldValues && data.fieldValues['RowItem'] && data.fieldValues['RowItem']) {
            this.rowItem = data.fieldValues['RowItem'];
            this.fieldVisibilities = data.fieldValues['FieldVisibilities'];
            this.initialize();
            this.rowItemEvent.emit(this.rowItem);
            if (this.invalidateSubject) {
              const invalidateId = 'Refresh|' + Guid.create().toString();
              this.invalidateSubject.invalidate(invalidateId);
            }
          }
        });
      }
      if (state.action === otherButtonCaption) {
        const value = this.rowItem.cells[node.item.fieldKey]?.value;
        const displayText = this.rowItem.cells[node.item.fieldKey]?.displayText;
        const command = this.magicLinkModel?.additionalCommands['UpdateFlowchartItemCommand'];
        if (this.magicLinkModel.fieldValues['DirectoryId']) {
          command.fieldValues['DirectoryId'] = this.magicLinkModel.fieldValues['DirectoryId'];
        }
        command.fieldValues['ItemId'] = this.rowItem?.id;
        command.fieldValues['FieldKey'] = node.item?.fieldKey;
        command.fieldValues['DirtyKeys'] = [node.item?.fieldKey];
        // we set section id. discussed with Shaon vai and further review
        command.fieldValues['FlowchartSectionId'] =this.section.id;
        if (displayText) {
          command.fieldValues[node.item?.fieldKey + 'DisplayText'] = displayText;
        }
        command.fieldValues[node.item?.fieldKey] = value;
        command.fieldValues['IsCleared'] = true;
        this.commandService.executePlatformCommand(command).pipe().subscribe(() => {
          delete command.fieldValues['IsCleared'];
          const invalidateId = 'Refresh|' + Guid.create().toString();
          this.invalidateSubject.invalidate(invalidateId);
        });
      }
    });
  }
  showFormulaFieldValidationSnackBarMessage() {
    this.snackBarService.showError(QnrFieldValidationMessage.formulaFieldValidationMessage);
  }
  openConversationForThisField(key) {
    const fieldDefinition = this.fieldDefinitions[key.item.fieldKey];
    const formId = this.rowItem.id;
    const sourceKey = 'CellEditor';
    const chatTitle = `${fieldDefinition.header}`;
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        itemId: `${formId}`,
        fieldKey: `${key.item.fieldKey}`,
        relativeUrl: '',
        sourceTitle: ''
      }
    };
    if (!formId || !key.item.fieldKey) {
      return;
    }
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      chatTitle,
      true,
      0,
      sourceKey,
      [],
      true,
      ``,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }

  hasFieldDetais(fieldKey) {
    let fieldDetailId = `${this.sourceType}-${fieldKey}`;
    if (this.rowItem.cells['ViewDetailsType']) {
      fieldDetailId = `${this.rowItem.cells['ViewDetailsType'].value}-${fieldKey}`;
    }
    fieldDetailId = fieldDetailId.toLowerCase();
    const fieldDetail = this.particleCacheService.getItem(fieldDetailId);
    if (fieldDetail && (fieldDetail.version === this.particleCacheService.getClientConfigVersion())) {
      return true;
    } else {
      return false;
    }
  }
  openDetailsPopUp(node: FlowChartUiFlatNode) {
    const header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: 15px;">' + node.item.title + '</div>';
    const fieldKey = node.item.fieldKey;
    let fieldDetailId = `${this.sourceType}-${fieldKey}`;
    if (this.rowItem.cells['ViewDetailsType']) {
      fieldDetailId = `${this.rowItem.cells['ViewDetailsType'].value}-${fieldKey}`;
    }
    fieldDetailId = fieldDetailId.toLowerCase();

    const details = this.particleCacheService.getItem(fieldDetailId);
    const dialogModel: DialogModel = DialogModel.create(
      'Details',
      'ViewDetailsComponent',
      {
        viewDetails: details.value.Details
      },
      '600px',
      '700px'
    );
    dialogModel.okCaption = '';
    dialogModel.cancelCaption = '';
    this.platformSidebarStore.dispatch(
      new SetCurrentRightSideComponentAction(
        { component: 'ViewDetailComponent', data: { isUserAction: true }, componentInfo: { id: 'ViewDetailComponent' } }));
    const ViewDetailObj = header + details.value.Details;
    this.platformSidebarStore.dispatch(new SetCurrentViewDetailAction(ViewDetailObj));
    /*this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
      // console.log(res);
    });*/
  }

  closeRightSidebar() {
    // if (this.sidebarService.getSidebar('rightsidebar')) {
    //   this.sidebarService.getSidebar('rightsidebar').close();
    //   this.sidebarService.getSidebar('rightsidebar').fold();
    // }
    // this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction(null));
    // this.platformSidebarStore.dispatch(new SetCurrentRightSideBarFoldOrNotAction(true));
  }

  openDetailsAndInstructions(node: any) {
    // this.detailsInstructionService.openDetailsInstructionPopUp(this.sourceType, node.item.fieldKey);
    const header = '<div style="margin-bottom: 20px;font-weight: bold;font-size: 15px;">' + node.item.title + '</div>';
    this.detailsInstructionService.getDetailsInstruction(InstructionDetailsSourceViewType.flowchart, this.sourceType, node.item.fieldKey).subscribe(data => {
      if (data) {
        const viewDetailObj = {};
        viewDetailObj['notes'] = header;
        if (data.details) {
          viewDetailObj['notes'] += data.details;
        }
        if (data.attachments) {
          viewDetailObj['attachments'] = data.attachments;
        }
        this.detailsInstructionService.setViewDetail(viewDetailObj, true);
      } else {
        const detailMessage = '<p><strong>No additional details available.</strong></p>';
        const fieldDetail = header + detailMessage;
        const viewDetailObj = {};
        viewDetailObj['notes'] = fieldDetail;
        this.detailsInstructionService.setViewDetail(viewDetailObj, true);
      }
    });
  }

  askXatBot(node: any) {
    this.xatBotThreadService.askXatBot(this.flowchart.id, this.selectedTab.tabData["SurveyFlowchartSectionId"], node, this.rowItem.id);
  }

  private executeCommandToApi(command: PlatformCommand, callBack?: any) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
        console.log('[PlatformCommand] Command Response', commandResponse);
        if (commandResponse.fieldValues['SnackBarMessage']) {
          const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
          this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
        }
        if (commandResponse.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
        }
        if (callBack) {
          callBack(commandResponse);
        }
        this.fuseSplashScreenService.hide();
      },
        error => {
          console.error('Failed PlatformToolQuestionnaireResponseComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  onToggleInputTypeForNumberField(node: any, inputType: string) {
    console.log(node);
    const toogleCommand = new PlatformCommand('ToggleDataItemInputTypeCommand', Api.FileStoreApi);
    toogleCommand.setValue('DataItemId', this.rowItem.id);
    toogleCommand.setValue('FieldKey', node.item.fieldKey);
    toogleCommand.setValue('FlowchartSectionId', this.section.id);
    toogleCommand.setValue('FlowchartId', this.flowchart.id);
    toogleCommand.setValue('InputType', inputType);
    toogleCommand.setValue('PlatformLinkId', this.magicLinkModel.id);
    this.commandService.executePlatformCommand(toogleCommand).pipe().subscribe(commandResponse => {
      const invalidateId = 'Refresh|' + Guid.create().toString();
      this.invalidateSubject.invalidate(invalidateId);
      if (commandResponse.fieldValues['PlatformLinkModel']) {
        this.magicLinkModelValueChanged.emit({
          id: 'PlatformToolContainerComponent',
          value: commandResponse.fieldValues['PlatformLinkModel']
        })
      }
    });
  }


  private hasFormulaExpression(dataType: string, fieldValues: any) {
    return (dataType === 'Number' || dataType === 'Percentage') && fieldValues
      && fieldValues['FormulaExpression'] != null;
  }

  private isUseFormula(node: FlowChartNode) {
    const keyName = node.fieldKey + '-UseFormula';
    return this.hasFormulaExpression(node.dataType, node.fieldValues) && (!this.rowItem.cells[keyName] || this.rowItem.cells[keyName].value);
  }

  private navigateToSelectedQuestion(selectedQuestionKey: string) {
    const selectedQuestion = this.data.find(question => question.fieldKey === selectedQuestionKey);
    if (selectedQuestion) {
      this.selectedNodeId = selectedQuestion.id;
      const element = document.getElementById(this.selectedNodeId);
      if (element) {
        element.scrollIntoView({ block: 'center', inline: 'nearest' });
        element.focus();
      }
    }
  }

  ngAfterViewInit(): void {
    this.navigateToSelectedQuestion(this.selectedTab.tabData['SelectedQuestionKey']);
  }

  hasQualifyingSurvey(header: string) {
    return this.flowChartDataService.hasSurveyField(header);
  }
}
